<template>
  <div class="wallet-form-shell py-8">
    <v-card
      class="d-flex flex-column justify-center mb-4"
      elevation="0"
      height="112"
    >
      <v-card-text>
        <reward-link-logo
          height="60"
          width="100%"
          :color="logoColor"
        />
      </v-card-text>
    </v-card>
    <div class="wallet-form">
      <v-card elevation="0">
        <v-card-text class="pa-12 text-center">
          <slot />
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>

<script>
import RewardLinkLogo from '@/components/footer/RewardLinkLogo'
import { TangoCardColors } from '@tangocard/swag'

export default {
  name: 'WalletFormShell',
  components: { RewardLinkLogo },
  computed: {
    logoColor: () => TangoCardColors.orange_800
  }
}
</script>

<style scoped lang="scss">
.wallet-form-shell,
.wallet-form {
  max-width: 500px;
  margin: 0 auto;
}
</style>
